import React from 'react'
import { useFormContext } from 'react-hook-form'

import './DefaultItemViewSection.scss'

const viewOptions = [
  {
    id: 'list',
    label: 'List',
  },
  {
    id: 'tile',
    label: 'Tile',
  },
]

const DefaultItemViewSection = () => {
  const { watch, setValue } = useFormContext()
  const selectedView = watch('defaultItemView') || 'list'

  return (
    <div className='settings-section'>
      <div className='settings-section-header'>
        <span className='settings-section-title'>Default Item View</span>
      </div>

      <div className='settings-section-body settings-default-view-section-body'>
        <p className='settings-default-view-description'>
          How products appear by default when members open an event. Members can still switch while
          browsing.
        </p>

        <div className='settings-default-view-grid'>
          {viewOptions.map((option) => (
            <button
              key={option.id}
              type='button'
              className={`settings-default-view-card ${selectedView === option.id ? 'is-active' : ''}`}
              onClick={() => setValue('defaultItemView', option.id)}
            >
              <span
                className={`settings-default-view-check ${selectedView === option.id ? 'is-active' : ''}`}
              />

              <span className='settings-default-view-card-content'>
                <span className='settings-default-view-card-title'>{option.label}</span>

                {option.id === 'list' ? (
                  <span className='settings-default-view-list-preview'>
                    <span className='settings-default-view-list-row'>
                      <span className='settings-default-view-list-thumb is-mint' />
                      <span className='settings-default-view-list-bar is-long' />
                    </span>
                    <span className='settings-default-view-list-row'>
                      <span className='settings-default-view-list-thumb is-sand' />
                      <span className='settings-default-view-list-bar is-short' />
                    </span>
                  </span>
                ) : (
                  <span className='settings-default-view-tile-preview'>
                    <span className='settings-default-view-tile-card'>
                      <span className='settings-default-view-tile-image is-mint' />
                      <span className='settings-default-view-tile-bar' />
                    </span>
                    <span className='settings-default-view-tile-card'>
                      <span className='settings-default-view-tile-image is-sand' />
                      <span className='settings-default-view-tile-bar' />
                    </span>
                  </span>
                )}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default DefaultItemViewSection
